<template>
    <div class="">

        <div v-if="reservation.billing" class="row">
            <div class="col-sm-4">
                <label>
                    VAT Number
                </label>
                <input type="text" class="full mb-3" v-model="reservation.billing.details.vat" :disabled="readOnly">
            </div>

            <div class="col-sm-4">
                <label>
                    City
                </label>
                <input type="text" class="full mb-3" v-model="reservation.billing.details.city" :disabled="readOnly">
            </div>

            <div class="col-sm-4">
                <label>
                    Country
                </label>
                <v-select :options="getCountries" label="name" v-model="selectedCountry" @input="selectedCountryChanged" :disabled="readOnly"></v-select>
            </div>

            <div class="col-sm-6">
                <label>
                    Billing name
                </label>
                <input type="text" class="full mb-3" v-model="reservation.billing.details.businessName" :disabled="readOnly">
            </div>

            <div class="col-sm-6">
                <label>
                    Address
                </label>
                <input type="text" class="full mb-3" v-model="reservation.billing.details.address" :disabled="readOnly">
                <button class="w-100 w-100 mb-2 bg-lightest darker text-center font-weight-600 py-3 border-light radius-normal pointer" :class="{'opacity-50 notAllowed':unsavedChanges}" v-if="compShowInvoiceBtn" :disabled="isSavingReservation || getIsCreatingInvoice" @click="startCreateInvoice">{{getIsCreatingInvoice? 'Invoicing...':'Invoice'}}</button>
            </div>
        </div>

        <div v-else class="dark text-center m-5 w-100">
            <div class="fs-large darker">Unable to load information</div>
        </div>
    </div>
</template>

<script>
import {mapGetters} from 'vuex'
import extendedVSelect from '@/extends/vue-select'
export default {
    data: function() {
        return {
            selectedCountry: null
        }
    },
    props: {
        reservation: {
            type: Object
        },
        showInvoiceBtn:{
            type: Boolean,
            default: true,
        },
        readOnly: {
            type: Boolean,
            default: false
        }
    },
    created: function(){
        //se the correct selected country
        this.setSelectedCountry(this.reservation.billing.details.country)
    },
    computed:{
        ...mapGetters([
            'getCountries',
            'getCompanySettings',
            'getIsSavingReservation',
            'getIsCreatingInvoice'
        ]),
        compShowInvoiceBtn: function () {
            if(this.showInvoiceBtn && this.getCompanySettings.settingsPresets && this.getCompanySettings.settingsPresets.hasInvoiceSystem && this.getCompanySettings.settingsPresets.invoiceSystem.isActive && this.reservation.id){
                return true
            } else {
                return false
            }
        },
        unsavedChanges: function () {
            let output = false

            if(this.reservation.updateFlags){
                for (var updateFlag in this.reservation.updateFlags) {
                    if (updateFlag == true) {
                        output = true
                    }
                }
            }

            return output
        },
        isSavingReservation: function () {
            return this.getIsSavingReservation
        }
    },
    methods: {
        selectedCountryChanged: function(e) {
            this.reservation.billing.details.country = e.id
        },
        setSelectedCountry: function(countryId) {
            this.selectedCountry = this.getCountries.filter(country => {
                return country.id == countryId
            })[0]
        },
        startCreateInvoice: function () {
            if(this.unsavedChanges){
                this.$dialog.alert('There are unsaved changes, you must save the reservation before invoicing.', {okText: 'OK'})
                .then(function () {

                })
                .catch(function () {
                });

                return false
            }

            this.eventHub.$emit('editReservation_toggleCreateInvoice')
            // this.createInvoice(this.reservation.id)
        }
    },
    components: {
        vSelect: extendedVSelect
    },
    watch:{
        'reservation.billing.details.country': {
            handler: function (newVal, oldVal) {
                this.setSelectedCountry(newVal)
            }
        }
    }
}
</script>

<style lang="scss" scoped>
    @import '../../../../../assets/scss/_variables';
    input{
        background-color: $lighter
    }
</style>



// WEBPACK FOOTER //
// BillingDetails.vue?5efcb678